import { render, staticRenderFns } from "./create-course-producer.html?vue&type=template&id=6762d576&scoped=true&"
import script from "./create-course-producer.js?vue&type=script&lang=js&"
export * from "./create-course-producer.js?vue&type=script&lang=js&"
import style0 from "./create-course-producer.scss?vue&type=style&index=0&id=6762d576&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6762d576",
  null
  
)

export default component.exports